<div class="footer"
     [ngClass]="{
      'footer--with-copyrights': copyrightsVisible,
      'footer--with-products': featuredProductsVisible,
      'footer--agent-context': isAgentContext
      }"
>
    <img *ngIf="footerTopBackgroundVisible"
         class="footer__top-background"
         [src]="footerTopBackgroundImageSrc"
         alt="">

    <div class="footer__content-wrapper">
        <div class="footer__content main">
            <div *ngIf="headerVisible"
                 class="footer__header"
                 [innerHTML]="'FOOTER.HEADER' | translate | safeHtml"
            ></div>
            <div *ngIf="contentLpVisible"
                 class="footer__content__lp">
                <ng-container *ngTemplateOutlet="footerLp"></ng-container>
            </div>

            <div *ngIf="resourcesVisible"
                 class="footer__resources">
                <div class="footer__resources__lp">
                    <ng-container *ngTemplateOutlet="footerLp"></ng-container>
                </div>

                <div class="footer__resources__contact">
                    <a class="footer__resources__contact-item"
                       [href]="'tel:' + data.phoneNumber"
                    >
                        <img [src]="phoneNumberIcon" alt="">
                        <span class="bold">{{ data.phoneNumber }}</span>
                    </a>
                    <a class="footer__resources__contact-item"
                       [href]="'mailto:' + data.email"
                    >
                        <img [src]="emailIcon" alt="">
                        <span class="bold">{{ data.email }}</span>
                    </a>
                </div>

                <div *ngIf="socialMediaVisible"
                     class="footer__resources__social-media">
                    <a *ngFor="let urlIcon of data.socialMediaUrlIcons"
                       [href]="urlIcon.url"
                       target="_blank"
                    >
                        <img [src]="urlIcon.icon" alt="">
                    </a>
                </div>
            </div>

            <div *ngIf="featuredProductsVisible"
                 class="footer__featured-products">
                <div class="footer__featured-products__products">
                    <app-featured-product-icon-group></app-featured-product-icon-group>
                </div>
            </div>

            <div class="footer__bottom"
            >
                <div *ngIf="copyrightsVisible"
                     class="footer__bottom__copyright">
                    {{ 'FOOTER.COPYRIGHT' | translate:true:copyrightsTranslateParams }}
                </div>
                <div class="footer__bottom__resources">
                    <a *ngFor="let resource of data.resources"
                       [href]="resource.value"
                       target="_blank"
                       class="footer__bottom__resource"
                    >
                        {{ resource.label | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>

</div>

<ng-template #footerLp>
    <div class="footer__lp">
        <a [href]="data.landingPageUrlIcon.url" target="_blank">
            <img [src]="data.landingPageUrlIcon.icon" alt="">
        </a>
        <img *ngIf="additionalLogo"
             class="footer__lp__additional-logo"
             [src]="additionalLogo"
             alt="">
    </div>
</ng-template>
